export const UPDATE_LIST_OF_LOCATIONS = 'UPDATE_LIST_OF_LOCATIONS'
export const GET_LOCATION_TYPES = 'GET_LOCATION_TYPES'
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION'
export const SET_CURRENT_LOCATION_OPEN_HOURS = 'SET_CURRENT_LOCATION_OPEN_HOURS'
export const SET_LOCATIONS_ERROR = 'SET_LOCATIONS_ERROR'
export const CLEAR_LOCATIONS_ERROR = 'CLEAR_LOCATIONS_ERROR'
export const DELETE_LOCATION = 'DELETE_LOCATION'
